import { campaignPhase } from "../../constants/campaign.constant";

export const getCampaignNameFromPhase = (phase) => {
  const campaign = campaignPhase.find((item) => item.key === phase);
  return campaign?.value;
}

export const getCampaignProgress = (phase) => {
  const newCampaign = [];
  let color = 'green';
  for (const item of campaignPhase) {
    newCampaign.push({
      ...item,
      color
    });
    if(item.key === phase) {
      color = 'grey';
    }
  }
  return newCampaign;
};

export const getStateNameById = (id) => {
  const geoStates = JSON.parse(localStorage.getItem('GEO_STATES')) || [];
  if (geoStates) {
    const state = geoStates.find((item) => item.province === id);
    return state?.details.name;
  }
  return "";
}

export const getStateNameByDistrict = () => {
  const geoStates = JSON.parse(localStorage.getItem('GEO_STATES')) || [];
  const parentProvince = geoStates.find(province =>
      province.districts.some(district => district.district === "SINDHULI")
  );
  console.log(parentProvince);
  return parentProvince;
}
